<template>
  <div class="container registerBody">
    <h4>
      Rejestracja jako nowy klient
    </h4>
    <RegisterForm title="Nowy użytkownik">
    <form action="" class = "registerForm">
      <div class="row">
        <div class="col-sm-4">
          <label for="email">E-mail</label>
          <input id="email" name="email" class="form-control" type="text" v-model="email"  v-on:blur="emailCheck" />
          <p class="text-danger small"  v-if="errors['email']">
              {{ errors["email"] }}
          </p>
          <p class="text-danger small"   v-if="errors['emailF']">
              {{ errors['emailF'] }}
          </p>
        </div>
        <div class="col-sm-4">
          <label for="password">Hasło</label>
          <input id="password" name="password" class="form-control" type="password" v-model="password" v-on:blur="passwordCheck" />
          <p class="text-danger small"   v-if="errors['passwordLength']">
              {{ errors['passwordLength'] }}
          </p>
        </div>
        <div class="col-sm-4">
          <label for="passwordRepeat">Powtórz hasło</label>
          <input id="passwordRepeat" name="passwordRepeat" class="form-control" type="password" v-model="passwordRepeat" v-on:blur="passwordRepeatCheck" />
          <p class="text-danger small"   v-if="errors['passwordRepeat']">
              {{ errors['passwordRepeat'] }}
          </p>
          <p class="text-danger small"   v-if="errors['passwordIncorrect']">
              {{ errors['passwordIncorrect'] }}
          </p>
        </div>
      </div>
      <div class="row">
          <div class="col-sm-4">
            <label for="krs">KRS</label>
            <input id="krs" name="krs" class="form-control" type="text" v-model="krs" />  
          </div>
          <div class="col-sm-4">
            <label for="nip">NIP</label>
            <input id="nip" name="nip" class="form-control" type="text" v-model="nip" />  
          </div>
          <div class="col-sm-4">
            <label for="regon">REGON</label>
            <input id="regon" name="regon" class="form-control" type="text" v-model="regon" />  
          </div>
      </div>
      <div class="row">
          <div class="col-sm-8">
              <label for="companyName">Nazwa firmy</label>
              <input id="companyName" name="companyName" class="form-control" type="text" v-model="companyName" v-on:blur="companyNameCheck" />  
              <p class="text-danger small"   v-if="errors['companyName']">
                  {{ errors['companyName'] }}
              </p>
          </div>
          <div class="col-sm-4">
            <label for="file">Załaduj plik</label>
            <input id = "file" type="file" @change="onFileChange">
            <span v-if="selectedFile">
              <button @click="removeFile">Usuń plik</button>
            </span>
          </div>
      </div>
      <div class="row">
          <div class="col-sm-4">
              <label for="forName">Imię</label>
              <input id="forName" name="forName" class="form-control" type="text" v-model="forName" />  
            </div>
            <div class="col-sm-4">
              <label for="lastName">Nazwisko</label>
              <input id="lastName" name="lastName" class="form-control" type="text" v-model="lastName" />  
            </div>
            <div class="col-sm-4">
              <label for="phoneNumber">Telefon</label>
              <input id="phoneNumber" name="phoneNumber" class="form-control" type="text" v-model="phoneNumber" v-on:blur="phoneNumberCheck" />  
            </div>
      </div>
      <div class="row">
          <div class="col-sm-8">
              <label for="street">Ulica</label>
              <input id="street" name="street" class="form-control" type="text" v-model="street" />  
            </div>
            <div class="col-sm-2">
              <label for="streetNumber">Numer</label>
              <input id="streetNumber" name="streetNumber" class="form-control" type="text" v-model="streetNumber" />  
            </div>
            <div class="col-sm-2">
              <label for="postalCode">Kod pocztowy</label>
              <input id="postalCode" name="postalCode" class="form-control" type="text" v-model="postalCode" />  
            </div>
      </div>
      <div class="row">
          <div class="col-sm-4">
              <label for="city">Miasto</label>
              <input id="city" name="city" class="form-control" type="text" v-model="city" />  
            </div>
            <div class="col-sm-4">
                 <div class="form-group">
                <label for="country">Kraj</label>
                <select v-model="country"  id="country" name="country" class="form-control">
                <option v-for="country in company.countries" :value="country.id">{{ country.name }}</option>
                </select>
              </div>   
            </div>
            <div class="col-sm-2">
              <label for="acceptRegulations">Akceptuję regulamin serwisu</label>
              <input id="acceptRegulations" name="acceptRegulations" class="checkbox" type="checkbox" v-model = "checkboxRegulationsVal" v-on:change = "checkboxRegulations" /> 
               <p class="text-danger small"   v-if="checkboxRegulationsVal==false">
                  {{ errors['acceptedRegulations'] }}
              </p>
            </div>
            <div class="col-sm-2">
              <label for = "newsletter">Newsletter</label>
              <input id = "newsletter" name = "newsletter" class = "checkbox" type = "checkbox"  v-model = "newsletter" /> 
            </div>
      </div>
      <div class="row">
         <label for="acceptRodo">Wyrażam zgodę na przetwarzanie moich danych osobowych przez firmę {{ companyData }} w celu założenia i utrzymywania mojego konta użytkownika na warunkach opisanych w REGULAMINIE i przy zachowaniu przepisów rozporządzenia o ochronie danych osobowych (RODO). Zostałem poinformowany, że zgodę mogę wycofać w dowolnym momencie. Zostałem poinformowany, że mam prawo wglądu, poprawiania oraz żądania usunięcia moich danych osobowych w dowolnej chwili.</label>
              <input id="acceptRodo" name = "acceptRodo" class = "checkbox" type = "checkbox" v-model = "checkboxRodoVal" v-on:change = "checkboxRodo" /> 
             <p class="text-danger small"   v-if="checkboxRodoVal==false">
                  {{ errors['acceptedRodo'] }}
              </p>
      </div>
      <button id = "submitButton" :disabled = "disabled" class = "btn btn-success">Submit</button>
      </form>
      </RegisterForm>
  </div>
</template>
<script>
import RegisterForm from './registerForm.vue'
import { mapState } from 'vuex'
export default {
  components: {RegisterForm},
  data () {
    return {
      email: '',
      password: '',
      passwordRepeat: '',
      krs: '',
      nip: '',
      regon: '',
      companyName: '',
      selectedFile: '',
      forName: '',
      lastName: '',
      street: '',
      streetNumber: '',
      postalCode: '',
      city: '',
      phoneNumber: '',
      newsletter: false,
      disabled: true,
      errors: [],
      country: 1,
      companyData: 'Krzak',
      disabled: true,
      checkboxRodoVal: false,
      checkboxRegulationsVal: false,
      
    }
  },
   methods:{
      emailCheck() {
        if(!this.email) this.errors['email'] = "Email wymagany.";
        let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(this.email)) this.errors['emailF'] = "Niepoprawny format email.";
        if(this.email) delete this.errors['email'];
        if (filter.test(this.email)) delete this.errors['emailF'];
        if(!this.errors.push()){
          return true;
        };
     },
      passwordCheck() {
        this.password=this.password.trim()
        if(this.password.length < 8 || !this.password) this.errors['passwordLength'] = "Hasło musi mieć długość przynajmniej 8 znaków.";
        if(this.password.length > 7) delete this.errors['passwordLength'];
        if(!this.errors.push()){
          return true;
        };
     },
      passwordRepeatCheck() {
        this.passwordRepeat = this.passwordRepeat.trim()
        if(!this.passwordRepeat) this.errors['passwordRepeat'] = "Powtórz ponownie hasło.";
        if((this.passwordRepeat != this.password) && this.passwordRepeat.length > 0) this.errors['passwordIncorrect'] = "Hasła nie są identyczne.";
        if(this.passwordRepeat.length) delete this.errors['passwordRepeat'];
        if(this.passwordRepeat==this.password) delete this.errors['passwordIncorrect'];
        if(!this.errors.push()){
          return true;
        };
     },
      checkboxRegulations() {
        if(!this.checkboxRegulationsVal){
          this.errors['acceptedRegulations'] = "Musisz zaakceptować regulamin";
        } else {
          delete this.errors['acceptedRegulations'];
        }
        if(!this.errors.push()){
          return true;
        };
     },
      checkboxRodo() {
        if(!this.checkboxRodoVal){
         this.errors['acceptedRodo'] = "Musisz zaakceptować regulamin";
        } else {
         delete this.errors['acceptedRodo']
        }
        if(!this.errors.push()){
          return true;
        };
     },
      companyNameCheck() {
      if(!this.companyName) this.errors['companyName'] = "Nazwa firmy jest wymagana";
      if(this.companyName) delete this.errors['companyName'];
      if(!this.errors.push()){
          return true;
        };
     },
      phoneNumberCheck() {
        var numeric = [];
       for(var i = 0; i < this.phoneNumber.length; i++){
         if(isNaN(this.phoneNumber[i])) continue;
         numeric.push(this.phoneNumber[i]);
       }
       this.phoneNumber = numeric.join("");
     },
      onFileChange(e) {
        console.log(e)
        this.selectedFile = this.selectedFile = e.target.files[0].name
        console.log(this.selectedFile)
    },
      removeFile(e) {
       document.getElementById('file').value = '';
       this.selectedFile = '';
      },
   },
   computed: {
        compoundProperty() {
          if(Object.values(this.errors).length == 0 && this.passwordRepeat && this.companyName){
            this.disabled = false;
          } else {
            this.disabled = true;
          }
        },
         ...mapState({
        company: state => state.company,
      }),
    },
   watch: {
     compoundProperty() {
      return this.compoundProperty()
     },
   },
   mounted() {
     this.errors['acceptedRegulations'] = "Musisz zaakceptować regulamin";
     this.errors['acceptedRodo'] = "Musisz zaakceptować rodo";
     this.errors.push();
   },
      beforeMount() {
      this.$store.dispatch('company/countries');
    },

}
</script>



// WEBPACK FOOTER //
// src/components/registerForm/registerForm.vue